query IsCampaignLocked($campaignId: ID!) {
    campaign(campaignId: $campaignId) {
        _id
        isLocked
    }
}
